<template>
  <div>
    <van-row>
      <van-notify id="custom-selector" />
      <van-col span="24">
        <h3>无牌车出场</h3>
        <van-empty image-size="120" image="search" description="请输入入场时的6位车牌" />
      </van-col>
      <van-col span="24">
          <no-plate-number :pageType="this.pageType" @getPlateLicense="getPlateLicense" ></no-plate-number>
      </van-col>
      <van-number-keyboard
        v-model="total"
        :show="show"
        theme="custom"
        close-button-text="完成"
        :maxlength="4"
        extra-key="."
        @blur="show = false"
      />
      <van-col span="24" style="margin-top: 5px">
        <div>
          <van-button type="info" size="large" style="width: 95%" @click="confirmOut">确认</van-button>
        </div>
      </van-col>
    </van-row>
    <van-row v-if="showNo" style="position:relative;top: 20vh;">
      <van-col span="24">
        <van-icon name="question-o" size="45px" color="#ff976a" />
      </van-col>
      <van-col span="24">
        <p>{{message}}</p>
      </van-col>
      <van-col span="24" style="margin-top: 15px">
        <div>
          <van-button type="warning" size="large" style="width: 95%" @click="back">返 回</van-button>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Vue from 'vue'
import noPlateNumber from '@/components/NoPlateNumber.vue'
import { CouponCell, CouponList, Dialog, Icon, Notify, Toast } from 'vant'

import * as noNumber from '@/api/noPlateNumber'
import {confirmIn} from "@/api/noPlateNumber";

const coupon = {
  available: 1,
  reason: '',
  value: 150,
  startAt: 1489104000,
  endAt: 1514592000,
  valueDesc: '1.5',
  unitDesc: '元'
}

Vue.use(CouponCell).use(CouponList)
Vue.use(Icon)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Notify)

export default {
  components: {
    noPlateNumber
  },
  data () {
    return {
      show: false,
      showNo: false,
      type: '',
      parkId: '',
      outChannelId: '',
      parkingName: '',
      message: '',
      carNumber: '',
      showList: false
    }
  },
  watch: {
    total (newValue, oldValue) {
      if (newValue !== '0.') {
        if (oldValue.length === 1 && parseInt(oldValue) === 0) {
          this.total = newValue.substr(1)
        }
      }
    }
  },
  methods: {
    getUrlKey: function (name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [,''])[1].replace(/\+/g, '%20')
        ) || null
      )
    },

    toPay () {
      this.$router.push('/index?outPassId=' + this.outchannelId + 'parkId=' + this.parkId + "&carNumber=" + this.carNumber)
    },
    back () {
      WeixinJSBridge.call('closeWindow')
      // this.handleGetOrderInfo()
      // this.show = true
      // this.showNo = false
    },
    onBridgeReady () {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: 'wx2421b1c4370ec43b', // 公众号名称，由商户传入
          timeStamp: '1395712654', // 时间戳，自1970年以来的秒数
          nonceStr: 'e61463f8efa94090b1f366cccfbbb444', // 随机串
          package: 'prepay_id=u802345jgfjsdfgsdg888',
          signType: 'MD5', // 微信签名方式：
          paySign: '70EA570631E4BB79628FBCA90534C63FF7FADD89' // 微信签名
        },
        function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      )
    },
    confirmOut () {
      if (this.carNumber.length === 0) {
        Notify({ type: 'danger', message: '请输入正确的车牌' })
        return
      }

      Toast.loading({
        duration: 2000, // 持续展示 toast
        mask: true,
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      })

      this.$router.push('/index?outPassId=' + this.outChannelId + '&parkId=' + this.parkId + '&carNumber=' + this.carNumber)
    },
    getPlateLicense (data) {
      this.carNumber = data
    },
    beforeClose (action, done) {
      if (action === 'confirm') {
        setTimeout(done, 1000)
      } else {
        // todo
      }
    },

    async getParkingName () {
      let res = await noNumber.getParkingName(this.parkId)
      if (res.data.type === 'success') {
        this.parkingName = res.data.data
      } else {
        Notify({ type: 'danger', message: res.data.message })
      }
    }
  },
  mounted () {
    this.parkId = this.getUrlKey('parkId') || this.$route.query.parkId
    this.outChannelId = this.getUrlKey('outChannelId') || this.$route.query.outChannelId
  }
}
</script>
<style>
.van-cell__title {
  text-align: left !important;
}

.van-cell__value span {
  text-align: right !important;
}

h1 {
  margin-top: 0;
}
</style>
